import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { api } from "@/lib/api";

export function usePlanLimit(resource) {
  const [info, setInfo] = useState({ reached: false, used: null, limit: null });
  useEffect(() => {
    api
      .get("/my-subscription")
      .then(({ data }) => {
        const used = data?.usage?.[resource];
        const limit = data?.plan?.limits?.[resource];
        setInfo({
          used,
          limit,
          reached: limit != null && used != null && used >= limit,
        });
      })
      .catch(() => {});
  }, [resource]);
  return info;
}

export function PlanLimitBanner({ info, label }) {
  const navigate = useNavigate();
  if (!info?.reached) return null;
  return (
    <div
      className="mb-4 flex items-center gap-3 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3"
      data-testid="plan-limit-banner"
    >
      <AlertTriangle className="h-5 w-5 text-amber-600 shrink-0" />
      <div className="flex-1 text-sm font-body text-amber-900">
        <b>Limite do plano atingido</b> — seu plano permite {info.limit} {label} (em uso:{" "}
        {info.used}). A criação de novos está bloqueada.
      </div>
      <button
        className="text-sm font-semibold text-emerald-800 hover:underline shrink-0"
        onClick={() => navigate("/billing")}
        data-testid="plan-limit-upgrade"
      >
        Fazer upgrade →
      </button>
    </div>
  );
}
